module.exports = __webpack_public_path__ + "static/media/loading-img.604862b7.svg";